import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Check, ChevronDown } from "lucide-react";
import "./TenantStatusSelect.css";

const QBOT_OPTIONS = [
  { value: "0", label: "Pending", tone: "warning" },
  { value: "1", label: "In Progress", tone: "info" },
  { value: "2", label: "Approved", tone: "success" },
  { value: "3", label: "Suspended", tone: "error" },
];

const OTHER_PORTAL_OPTIONS = [
  { value: "0", label: "Pending", tone: "warning" },
  { value: "1", label: "Approved", tone: "success" },
  { value: "2", label: "Failed", tone: "error" },
  { value: "3", label: "Suspended", tone: "error" },
];

const resolveValue = (value) => {
  if (value == null || value === "") return "0";
  return String(value);
};

/**
 * Themed status dropdown for Tenant table — pill trigger + status menu items.
 */
const TenantStatusSelect = ({
  value,
  onChange,
  variant = "qbot", // "qbot" | "other"
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const options = variant === "qbot" ? QBOT_OPTIONS : OTHER_PORTAL_OPTIONS;
  const current = resolveValue(value);
  const selected =
    options.find((opt) => opt.value === current) || options[0];

  return (
    <Select
      className="tenant-status-select"
      value={current}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disabled={disabled}
      onChange={(e) => {
        e.stopPropagation();
        onChange?.(e.target.value);
      }}
      onClick={(e) => e.stopPropagation()}
      variant="standard"
      disableUnderline
      IconComponent={() => null}
      MenuProps={{
        classes: { paper: "tenant-status-menu" },
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
        disableScrollLock: true,
      }}
      renderValue={() => (
        <span
          className={`tenant-status-pill is-${selected.tone}${
            open ? " is-open" : ""
          }`}
        >
          <span className="tenant-status-dot" aria-hidden />
          <span className="tenant-status-label">{selected.label}</span>
          <ChevronDown className="tenant-status-chevron" aria-hidden />
        </span>
      )}
      inputProps={{ "aria-label": "Tenant workflow status" }}
    >
      {options.map((opt) => {
        const isActive = opt.value === current;
        return (
          <MenuItem
            key={opt.value}
            value={opt.value}
            className={`tenant-status-option is-${opt.tone}${
              isActive ? " is-active" : ""
            }`}
          >
            <span className="tenant-status-option-dot" aria-hidden />
            <span className="tenant-status-option-label">{opt.label}</span>
            {isActive ? (
              <Check className="tenant-status-option-check" aria-hidden />
            ) : (
              <span className="tenant-status-option-check-spacer" aria-hidden />
            )}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default TenantStatusSelect;
